<template>
	<div>
		<x-table
			:tableData="tableData"
			:tableHeaders="tableHeaders"
			border
			:pageModel="pageModel"
			:total="total"
			:fetchList="fetchUser"
			:clickData="clickData"
			@clickRight="clickRight"
		></x-table>
	</div>
</template>

<script type="text/javascript">
import {
	getGroupUserList,
	removeGroupUser
} from '@/api/group';
import {
	deepClone,
	
} from '@/utils/util';

export default {
	data() {
		return {
			pageModel: {
				page: 1,
				pageSize: 10
			},
			tableData: [],
			total: 0,
			tableHeaders: [{
				headerName: '学员昵称',
				headerKey: 'nickname'
			}, {
				headerName: 'ID',
				headerKey: 'uid'
			}, {
				headerName: '注册时间',
				headerKey: 'register_time'
			}, {
				headerName: '加入小组天数',
				headerKey: 'join_group_day'
			}, {
				headerName: '打卡天数（累计）',
				headerKey: 'sign_in_day_count'
			}],
			clickData: [{
				label: '移除',
				value: 'del'
			}]
		}
	},
	props: {
		close: Function,
		fetchList: Function,
		detail: Object
	},
	watch: {
		detail: {
			handler(val) {
				if (!val) return

				this.fetchUser()
			},
			immediate: true
		},
		canCoin() {

		}
	},
	methods: {
		
		fetchUser() {
			getGroupUserList({
				...this.pageModel,
				groupId: this.detail.id
			}).then(res => {
				this.total = res.data.total
				this.tableData = res.data.data
			})
		},
		clickRight({row}) {
			this.$confirm('是否移除该用户？', '提示').then(res => {
				removeGroupUser({
					uid: row.uid,
					groupId: this.detail.id
				}).then(res => {
					this.$message.success('移除成功')
					this.fetchUser()
				})
			})
		}
		
	}
}
</script>

<style lang="less">

</style>